import { MatchOptions } from "../components/matchOptions"
import { ReviewImageOptions, ReviewMatchOptions, ReviewMultipleChoiceOptios, ReviewOpenOptions, ReviewOrderOptions, ReviewTrueFalseOptions } from "../molecule/reviewOption"

export const ReviewFactory = ({exercise}) => {
    
    switch(parseInt(exercise.quiz_type)){
        case 1: return <ReviewMultipleChoiceOptios exercise={exercise} />
        case 2:return <ReviewMatchOptions exercise={exercise}/>
        case 3:return <ReviewTrueFalseOptions exercise={exercise}/>
        case 4:return <ReviewOrderOptions exercise={exercise}/>
        case 5:return <ReviewImageOptions exercise={exercise}/>
        case 6:return <ReviewOpenOptions exercise={exercise}/>
    }
}